// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2bq0I","content":"LayoutSettings_content__1W2Sg"};